import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { PoliciesService } from 'src/app/providers/policy/policies.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';

@Component({
  selector: 'app-item-list',
  templateUrl: './item-list.component.html',
  styleUrls: ['./item-list.component.scss'],
})
export class ItemListComponent implements OnInit {
  scopeId;
  seatId;
  pantry: any = [];
  mobile = '';
  name;
  constructor(
    private route: ActivatedRoute,
    public httpPolicy: PoliciesService,
    private notify: NotificationService
  ) {
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.scopeId = params.get('scopeId');
      this.seatId = params.get('seatId');
    });
  }

  ngOnInit(): void {
    this.getPantry({ scope_id: this.scopeId });
  }

  getPantry(data): void {
    this.httpPolicy.getPantryItems(data).subscribe((res) => {
      this.pantry = res.data;
    });
  }

  increment(item): void {
    item.qty += 1;
  }

  decrement(item): void {
    if (item.qty < 1) {
      return;
    }
    item.qty -= 1;
  }

  orderItem(): void {
    let tmp = [];
    this.pantry.forEach((element) => {
      element.items.forEach((ele) => {
        if (ele.qty > 0) {
          tmp.push(ele);
        }
      });
    });

    if (tmp.length == 0) {
      this.notify.showError('Please order atleast one item', 'Info!');
      return;
    }
    if (!this.mobile) {
      this.notify.showError('Please Enter your contact number', 'Info!');
      return;
    }
    if (!this.name) {
      this.notify.showError('Please Enter your name', 'Info!');
      return;
    }

    const params = {
      seat_id: this.seatId,
      scope_id: this.scopeId,
      contact_no: this.mobile,
      name: this.name,
      items: tmp,
    };

    this.httpPolicy.orderItem(params).subscribe((res) => {
      if (res.status) {
        this.notify.showSuccess(res.msg, 'Success!');
        this.getPantry({ scope_id: this.scopeId });
        this.name = '';
        this.mobile = '';
      } else {
        this.notify.showError(res.msg, 'Error!');
      }
    });
  }
}
